module.exports = __webpack_public_path__ + "6089dc9b2a8e20512c56c6a8ce681a37-Whats-811.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/homeHeader/assets/Whats-811.png
// module id = 694
// module chunks = 0